import RepositoryFactory from "../../marcom/Apicall/whatsApp";
// import RepositoryFactory from "@/marcom/Apicall/RepositoryFactory";
// const smsCampaign = RepositoryFactory.smsCampaign;

export default {
  getAllTemplate({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await RepositoryFactory.getAllTemplate(payload);
        // const data = await RepositoryFactory.getAllTemplate(payload);

        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  create({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await RepositoryFactory.create(payload);
        // const data = await RepositoryFactory.getAllTemplate(payload);

        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  getwhatsAppConfig({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await RepositoryFactory.getwhatsAppConfig(payload);
        // const data = await RepositoryFactory.getAllTemplate(payload);

        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  createtwhatsAppConfig({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await RepositoryFactory.createwhatsAppConfig(payload);
        // const data = await RepositoryFactory.getAllTemplate(payload);

        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  createTemplate({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await RepositoryFactory.createTemplate(payload);
        // const data = await RepositoryFactory.getAllTemplate(payload);

        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
};
